import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "config/store";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { IEdoQuiz } from "shared/model/edo-quiz.model";
import { deleteEntity } from "shared/reducers/entities/edo-quiz.reducer";
import { EntityState } from "shared/reducers/reducer.utils";

interface IDeleteQuizProps {
    quiz: IEdoQuiz;
    open: boolean;
    onClose: () => void;
}

const DeleteQuiz = (props: IDeleteQuizProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoQuiz>>(
        (state) => state.edoQuiz
    );

    const { quiz, open, onClose: handleClose } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(quiz.id));
    };

    useEffect(() => {
        if (open && updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Translate contentKey="entity.delete.title">
                    Confirm delete operation
                </Translate>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Translate
                        contentKey="edocendoApp.edoQuiz.delete.question"
                        interpolate={{ nome: quiz?.title }}
                    >
                        Are you sure you want to delete this EdoQuiz?
                    </Translate>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                </Button>
                <Button onClick={confirmDelete} color="primary">
                    <Translate contentKey="entity.action.delete">Delete</Translate>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteQuiz;